/** 列表默认每页条数 */
export const DEFAULT_PAGE_SIZE = 20;

export function createPaginationState(overrides = {}) {
  return {
    current: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    total: 0,
    ...overrides
  };
}

export function buildIndexColumn(paginationLike = {}) {
  const current = Number(paginationLike.current) || 1;
  const pageSize = Number(paginationLike.pageSize) || DEFAULT_PAGE_SIZE;
  return {
    title: '序号',
    key: '__row_index',
    width: 64,
    align: 'center',
    fixed: 'left',
    render: (_, __, index) => (current - 1) * pageSize + index + 1
  };
}

export function withIndexColumn(columns = [], paginationLike = {}) {
  if (columns[0]?.key === '__row_index') return columns;
  return [buildIndexColumn(paginationLike), ...columns];
}

export function mergeTablePagination(pagination) {
  const defaults = {
    pageSize: DEFAULT_PAGE_SIZE,
    showSizeChanger: true,
    showTotal: (total) => `共 ${total} 条`
  };
  if (pagination === false || pagination == null) {
    return defaults;
  }
  return { ...defaults, ...pagination };
}
